import { useEffect } from 'react';

const BackgroundApplier = () => {
  useEffect(() => {
    // Remove any existing background classes
    document.body.classList.forEach(className => {
      if (className.startsWith('bg-')) {
        document.body.classList.remove(className);
      }
    });

    // Apply the circular gradient background
    document.body.classList.add('bg-circular-gradient');

    // No need to return cleanup function as this should persist for the app lifetime
  }, []);

  // This component doesn't render anything
  return null;
};

export default BackgroundApplier;
